const LABEL_COLORS = [
  '#FCDEE8',
  '#FBD3E0',
  '#F6C5BE',
  '#FFC8AF',
  '#FFDEB5',
  '#FDEDC1',
  '#FBE983',
  '#C6F3DE',
  '#B3EFD3',
  '#A2DCC1',
  '#98D7E4',
  '#C9DAF8',
  '#E3D7FF',
  '#EBDBDE',
  '#E7E7E7',
]

export default LABEL_COLORS
